import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppErrors, NotFoundError } from '@fitness-force/errors';
import { environment } from 'apps/ff-frontend/src/environments/environment';
import { Observable, map, catchError, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ClientExportService {
  constructor(private http: HttpClient) { }

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    })
  };

  exportProspects(allparams: any, tenantId: any): Observable<any> {
    let parsedParams = new HttpParams();
    allparams.forEach((p: any) => {
      parsedParams = parsedParams.append(p.name, p.value);
    });
   
    return this.http.get( `${environment.BASE_URL}/tenants/${tenantId}/prospects/export`,{
      headers: this.httpOptions.headers, params: parsedParams
    }).pipe(
      map((res: any) => {
          return res
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  exportActiveClients(allparams: any, tenantId: any): Observable<any> {
    let parsedParams = new HttpParams()
    allparams.forEach((p: any) => {
      parsedParams = parsedParams.append(p.name, p.value);
    });
    return this.http.get( `${environment.BASE_URL}/tenants/${tenantId}/activeclients/export`,{
      headers: this.httpOptions.headers, params: parsedParams
    }).pipe(
      map((res: any) => {
          return res
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  exportExClients(allparams: any, tenantId: any): Observable<any> {
    let parsedParams = new HttpParams()
    allparams.forEach((p: any) => {
      parsedParams = parsedParams.append(p.name, p.value);
    });
    return this.http.get( `${environment.BASE_URL}/tenants/${tenantId}/exclients/export`,{
      headers: this.httpOptions.headers, params: parsedParams
    }).pipe(
      map((res: any) => {
          return res
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  exportIrregularClients(allparams: any, tenantId: any): Observable<any> {
    let parsedParams = new HttpParams()
    allparams.forEach((p: any) => {
      parsedParams = parsedParams.append(p.name, p.value);
    });
    return this.http.get( `${environment.BASE_URL}/tenants/${tenantId}/clients/client_at_risk/export`,{
      headers: this.httpOptions.headers, params: parsedParams
    }).pipe(
      map((res: any) => {
          return res
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  exportClientTrials(allparams: any, tenantId: any): Observable<any> {
    let parsedParams = new HttpParams()
    allparams.forEach((p: any) => {
      parsedParams = parsedParams.append(p.name, p.value);
    });
    return this.http.get( `${environment.BASE_URL}/tenants/${tenantId}/trials/export`,{
      headers: this.httpOptions.headers, params: parsedParams
    }).pipe(
      map((res: any) => {
          return res
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

}

